<template>
  <div class="contest-detail">
    <div class="detail-poster">
      <img :src="detail.banner" />
    </div>
    <div class="content">
      <div class="content-title">
        —— {{ title }} ——
      </div>
      <div style="margin-top: 75px" v-html="content"></div>
    </div>
  </div>
</template>
<script>
import { GetCommitment } from "@/api/social";

export default {
  components: {
   
  },
  data() {
    return {
      detail: {},
      content:'',
      title:'',
      id:0

    };
  },
  computed:{
    
  },
  filters: {
   
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      vm.$emit("changeFooter", "light");
    });
  },
  mounted() {
    this.id = this.$route.query.id;
    this.onGetDetail();
  },
  methods: {
    
    async onGetDetail() {
      try {
        const { data } = await GetCommitment({ id: this.id });
        this.detail = data.match;
        this.title = data.title
        this.content = data.content
      } catch (e) {
        console.log("eee-", e);
      }
    },
    
  },
};
</script>
<style lang="scss" scoped>
@import "./contestdetail.scss";
</style>
